import { useQuery } from '@tanstack/react-query';
import { TermsLayout } from 'client/modules/terms/layout/terms-layout/TermsLayout';
import { CacheKey } from 'infra/interfaces/cache';
import { getPublicLastedTerm } from 'infra/repositories/term';
import { TermTypes } from 'infra/repositories/term/types';

export const TermsOfUsePage = () => {
	const { data: currentTerm } = useQuery({
		queryKey: [CacheKey.TERMS_USE],
		queryFn: () => getPublicLastedTerm({ type: TermTypes.TERMS_USE }),
		staleTime: Infinity,
	});

	return (
		<TermsLayout
			type={currentTerm?.type}
			description={currentTerm?.description}
			readOnly
		/>
	);
};
